import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../services/API";

export const postNeighborhoodSavedNews = createAsyncThunk("postNeighborhoodSavedNews", async (newsId, { rejectWithValue }) => {
    try {
        const response = await axiosInstance.post(`/neighbor_news/save_news/${newsId}/`);
        const result = response.data;
        return result;
    } catch (error) {
        if (error.response) {
            return rejectWithValue(error.response.data);
        }
        return rejectWithValue(error.message);
    }
});

export const getNeighborhoodSavedNews = createAsyncThunk("getNeighborhoodSavedNews", async (page = 1, { rejectWithValue }) => {
    try {
        const response = await axiosInstance.get(`/neighbor_news/get_saved_news/?page=${page}`);
        const result = response.data;
        return { ...result, page };
    } catch (error) {
        if (error.response) {
            return rejectWithValue(error.response.data);
        }
        return rejectWithValue(error.message);
    }
});

export const loadMoreNeighborhoodSavedNews = createAsyncThunk("loadMoreNeighborhoodSavedNews", async (page, { rejectWithValue }) => {
    try {
        const response = await axiosInstance.get(`/neighbor_news/get_saved_news/?page=${page}`);
        const result = response.data;
        return { ...result, page };
    } catch (error) {
        if (error.response) {
            return rejectWithValue(error.response.data);
        }
        return rejectWithValue(error.message);
    }
});

export const NeighborhoodSavedNewsSlice = createSlice({
    name: "NeighborhoodSavedNews",
    initialState: {
        neighborhoodSavedNews: [],
        loading: false,
        loadingMore: false,
        currentPage: 1,
        hasMore: false,
        next: null,
        previous: null,
        error: null,
    },
    reducers: {
        resetSavedNews: (state) => {
            state.neighborhoodSavedNews = [];
            state.currentPage = 1;
            state.hasMore = false;
            state.next = null;
            state.previous = null;
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        // get saved news action promises (initial load)
        builder.addCase(getNeighborhoodSavedNews.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(getNeighborhoodSavedNews.fulfilled, (state, action) => {
            state.loading = false;
            state.neighborhoodSavedNews = action.payload?.results || [];
            state.next = action.payload?.next;
            state.previous = action.payload?.previous;
            state.hasMore = !!action.payload?.next;
            state.currentPage = action.payload?.page || 1;
        });
        builder.addCase(getNeighborhoodSavedNews.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        // load more saved news action promises
        builder.addCase(loadMoreNeighborhoodSavedNews.pending, (state) => {
            state.loadingMore = true;
            state.error = null;
        });
        builder.addCase(loadMoreNeighborhoodSavedNews.fulfilled, (state, action) => {
            state.loadingMore = false;
            const newResults = action.payload?.results || [];
            // Append new results to existing ones (avoid duplicates)
            const existingIds = new Set(state.neighborhoodSavedNews.map(item => item.news.id));
            const uniqueNewResults = newResults.filter(item => !existingIds.has(item.news.id));
            state.neighborhoodSavedNews = [...state.neighborhoodSavedNews, ...uniqueNewResults];
            state.next = action.payload?.next;
            state.previous = action.payload?.previous;
            state.hasMore = !!action.payload?.next;
            state.currentPage = action.payload?.page || state.currentPage + 1;
        });
        builder.addCase(loadMoreNeighborhoodSavedNews.rejected, (state, action) => {
            state.loadingMore = false;
            state.error = action.payload;
        });
    },
});

export const { resetSavedNews } = NeighborhoodSavedNewsSlice.actions;
export default NeighborhoodSavedNewsSlice.reducer;